import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';


import {AppComponent} from './app.component';
import {RouterModule} from "@angular/router";
import {VariablesService} from "./services/variables.service";
import {ResponseFilterService} from "./services/response-filter.service";
import {UserService} from "./services/user/user.service";
import {HttpClientModule} from "@angular/common/http";

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,HttpClientModule,
        RouterModule.forRoot([
            {path: '', loadChildren: './apps/lending/lending.module#LendingModule'},
            {path: 'login', loadChildren: './apps/login/login.module#LoginModule'},
            {path: 'base', loadChildren: './skeleton/skeleton.module#SkeletonModule'},
        ])
    ],
    providers: [VariablesService, ResponseFilterService, UserService],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts